export default __webpack_public_path__ + "4e53b1b5572c89c773f2a35ea5da1cbe.png";